<div *ngIf="this.getNotification() !== ''">
  <div class="alert_outer">
    <div class="alert__inner plain-text">{{ this.getNotification() }}</div>
  </div>
</div>
